import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getAdminQueryList,
  adminCloseTicket,
  adminCreateQuery,
} from '../../../../services/ticketDetails/admin';

export const ticketQueryKeys = {
  all: ['ticketQueries'],
  // Prefix shared by every page of a given ticket's list. Invalidating
  // with just this key (no page) busts the cache for ALL pages of that
  // ticket at once, since react-query matches query keys by prefix.
  listBase: (ticketId) => [...ticketQueryKeys.all, 'list', ticketId],
  // The actual key each page's query is stored under.
  list: (ticketId, page) => [...ticketQueryKeys.listBase(ticketId), page],
};

export function useAdminQueryList(ticketId, params = {}) {
  const { page = 1, limit = 10 } = params;

  return useQuery({
    queryKey: ticketQueryKeys.list(ticketId, page),
    queryFn: () => getAdminQueryList(ticketId, { page, limit }),
    enabled: Boolean(ticketId),
    staleTime: 10_000,
  });
}

export function useAdminCloseTicket({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: adminCloseTicket,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ticketQueryKeys.listBase(variables.ticketId) });
      onSuccess?.(data, variables);
    },
    onError,
  });
}

export function useAdminCreateQuery({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: adminCreateQuery,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ticketQueryKeys.listBase(variables.ticketId) });
      onSuccess?.(data, variables);
    },
    onError,
  });
}
